class ContactFormBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.tabs = block.querySelectorAll('.contact-form__tab');
    this.supportTabsWrapper = block.querySelector('.contact-form__support-tabs');
    this.supportTabs = block.querySelectorAll('.contact-form__support-tab');
    this.supportSelect = block.querySelector('#support-team');
    this.forms = block.querySelectorAll('.contact-form__form');

    this.initTabs();

    if (window.location.hash === '#sales') {
      const tab = [...this.tabs].find((tab) => tab.dataset.tab === 'sales');
      if (tab) tab.click();
    } else if (window.location.hash === '#pr') {
      const tab = [...this.tabs].find((tab) => tab.dataset.tab === 'pr');
      if (tab) tab.click();
    }
  }

  initTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.tabs.forEach((tab) => {
          tab.classList.remove('contact-form__tab--active');
          tab.classList.remove('has-dark-background');
        });

        tab.classList.add('contact-form__tab--active');
        tab.classList.add('has-dark-background');

        if (tab.dataset.tab === 'support') {
          this.supportTabsWrapper.classList.add('contact-form__support-tabs--visible');
        } else {
          this.supportTabsWrapper.classList.remove('contact-form__support-tabs--visible');

          this.supportTabs.forEach((tab) => {
            tab.classList.remove('contact-form__tab--active');
            tab.classList.remove('has-dark-background');
          });
        }

        this.forms.forEach((form) => form.classList.remove('visible'));

        const form = this.block.querySelector(`.contact-form__form--${tab.dataset.tab}`);

        if (form) {
          form.classList.add('visible');
          window.dispatchEvent(new Event('resize'));
        }

        if (tab.dataset.tab === 'support') {
          this.refreshSupportForms();
        } else {
          window.location.hash = tab.dataset.tab;
        }
      });
    });

    this.supportTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.supportTabs.forEach((tab) => {
          tab.classList.remove('contact-form__tab--active');
          tab.classList.remove('has-dark-background');
        });

        tab.classList.add('contact-form__tab--active');
        tab.classList.add('has-dark-background');

        this.forms.forEach((form) => form.classList.remove('visible'));

        const form = this.block.querySelector(`.contact-form__form--${tab.dataset.tab}`);

        if (form) {
          form.classList.add('visible');
          window.dispatchEvent(new Event('resize'));
        }
      });
    });

    this.supportSelect.addEventListener('change', () => this.refreshSupportForms());
  }

  refreshSupportForms() {
    const latamSupportForm = this.block.querySelector(`.contact-form__form--latam-support`);
    const globalSupportForm = this.block.querySelector(`.contact-form__form--global-support`);

    latamSupportForm.classList.remove('visible');
    globalSupportForm.classList.remove('visible');

    if (this.supportSelect.value == 'latam-support') {
      latamSupportForm.classList.add('visible');
    } else if (this.supportSelect.value == 'global-support') {
      globalSupportForm.classList.add('visible');
    }

    window.location.hash = this.supportSelect.value || 'support';

    window.dispatchEvent(new Event('resize'));
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.contact-form').forEach((block) => {
  new ContactFormBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=contact-form', ($block, attributes) => {
    new ContactFormBlock($block.find('.contact-form').get(0), attributes);
  });
}

export { ContactFormBlock };